import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Col, Row, Glyphicon } from "react-bootstrap";
import { Form } from "react-final-form";
import { DotLoader } from "react-spinners";
import { REQUEST } from "src/co/sura/config/ajax-wrapper";
import { consultarEstructuraEmpresa } from "../modulos/estructuraEmpresasActions";
import { generarXLSXEstructuraEmpresa } from "../modelo/EstructuraEmpresaXLS";
import { Mensaje } from "../../../general/componentes/Mensaje";
import TipoIdentificacion from "../../../general/componentes/TipoIdentificacion";
import NumericInput from "../../../general/componentes/NumericInput";
import PestañaEstructuraEmpresa from "./PestañaEstructuraEmpresa";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import { documentoEmpleador, tipoDocumentoEmpleador, tipoConsultaEstructura } from "../../config_general/modelo/TextosAyuda";
import TextoInputSelector from "../../../general/componentes/TextoInputSelector";
import { TipoConsulta } from "../modelo/TipoConsulta";

class EstructuraEmpresas extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
    }

    componentWillMount() {
        const dni = new URLSearchParams(this.props.location.search).get("dni");
        if (dni) {
            const usuario = this.props.dniUsuarioGestionLogin;
            this.props.dispatch(consultarEstructuraEmpresa(dni, undefined, usuario));
        }
    }

    render() {
        return (
            <div>
                <Row>
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Estructura de Empresas SAT</h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Buscar reporte con la estructura de la empresa afiliada</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="tipoConsulta">Consultar por:</label>
                                                <TextoAyuda texto={tipoConsultaEstructura} />
                                                <TextoInputSelector name="tipoConsulta" maestro={this.listarTipoConsulta()} />
                                                {errors.tipoConsulta &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.tipoConsulta}</span>
                                                    </div>
                                                }
                                            </Col>
                                            {
                                                values.tipoConsulta &&
                                                this.renderOpcionesConsulta(Number(values.tipoConsulta.value))
                                            }
                                        </Row>
                                        <div style={{ marginTop: `25px` }}>
                                            <Row className={"form-group"}>
                                                <Col sm={2}>
                                                    {
                                                        (this.props.estructuraEmpresa) &&
                                                        <a className="btns btn-success" onClick={() => this.descargarXLSEstructuraEmpresa()}>
                                                            <b>Exportar XLSX</b> &nbsp;<Glyphicon className={"download-alt"} glyph={"download-alt"} />
                                                        </a>
                                                    }
                                                </Col>
                                                <Col smOffset={6} sm={1}>
                                                    <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                        Limpiar
                                                    </button>
                                                </Col>
                                                <Col sm={2}>
                                                    <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                        <b>Consultar</b> &nbsp;<Glyphicon className={"search"} glyph={"search"} />
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderPestañaEstructuraEmpresa()}
                </Row>
            </div>
        );
    }

    renderOpcionesConsulta(codigoConsulta: number) {
        switch (codigoConsulta) {
            case 1:
                return (
                    <Col sm={3}>
                        <label htmlFor="consecutivoConsulta">Consecutivo Consulta</label>
                        <NumericInput name="consecutivoConsulta" placeholder="Ingrese un consecutvio" />
                    </Col>
                );
            case 2:
                return (
                    <div>
                        <Col sm={3}>
                            <label htmlFor="tipoDocumento">Tipo Documento Empleador</label>
                            <TextoAyuda texto={tipoDocumentoEmpleador} />
                            <TipoIdentificacion name="tipoDocumento" />
                        </Col>
                        <Col sm={3}>
                            <label htmlFor="documento">Documento Empleador</label>
                            <TextoAyuda texto={documentoEmpleador} />
                            <NumericInput name="documento" placeholder="Ingrese un documento" />
                        </Col>
                    </div>
                );
            default:
                return false;
        }
    }

    renderPestañaEstructuraEmpresa() {
        const { estadoConsulta, mensajeUsuario, consecutivoProceso, error } = this.props;

        switch (estadoConsulta) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={mensajeUsuario ? mensajeUsuario : "Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return (
                    <div>
                        <DotLoader size={25} />
                    </div>
                );
            case REQUEST.SUCCESS:
                if (error)
                    return (
                        <span>
                            <Mensaje type={"danger"} mensaje={` Ocurrio un error realizando la consulta con consecutivo ${consecutivoProceso}`} />
                        </span>
                    );
                if (!this.props.estructuraEmpresa)
                    return (
                        <span>
                            <Mensaje type={"success"} mensaje={` La consulta se encuentra en tramite con el consecutivo ${consecutivoProceso}`} />
                        </span>
                    );
                else
                    return (
                        <span>
                            <PestañaEstructuraEmpresa
                                consecutivoConsulta={this.props.consecutivoProceso}
                                estructuraEmpresa={this.props.estructuraEmpresa}
                                estructuraSuraEmpresa={this.props.estructuraSuraEmpresa}
                            />
                        </span>
                    );
            default:
                return false;
        }
    }

    validate = (values: any) => {
        const errors = {
            tipoConsulta: undefined,
            consecutivoConsulta: undefined,
            documento: undefined,
            tipoDocumento: undefined
        };

        if(!values.tipoConsulta)
            errors.tipoConsulta = "Por favor seleccione una de las opciones";

        if(values.tipoConsulta && values.tipoConsulta.value === 1 && !values.consecutivoConsulta)
            errors.consecutivoConsulta = "Por favor ingrese el consecutivo de la consulta realizada";

        if (values.tipoConsulta && values.tipoConsulta.value === 2) {
            if (!values.tipoDocumento)
                errors.tipoDocumento = "Por favor ingresa un DNI de una empresa para consultar";

            if (values.tipoDocumento && !values.documento)
                errors.documento = "Por favor ingrese un documento";

            if ((!values.tipoDocumento || values.tipoDocumento === "Selecciona...") && values.documento)
                errors.tipoDocumento = "Por favor seleccione un tipo de documento";
        }

        return errors;
    };

    onSubmit = (values: any) => {
        const consecutivoConsulta = values.consecutivoConsulta && values.tipoConsulta.value === 1 ? values.consecutivoConsulta : undefined;
        const dni = (values.tipoDocumento && values.documento && values.tipoConsulta.value === 2) ? (values.tipoDocumento + values.documento) : undefined;
        const usuario = this.props.dniUsuarioGestionLogin;
        this.props.dispatch(consultarEstructuraEmpresa(dni, consecutivoConsulta, usuario));
    };

    descargarXLSEstructuraEmpresa() {
        if (this.props.estructuraEmpresa) {
            generarXLSXEstructuraEmpresa(this.props.estructuraEmpresa, this.props.estructuraSuraEmpresa);
        }
    }

    listarTipoConsulta = () => {
        return [].concat(
            TipoConsulta.map(value => ({
                value: value.codigo,
                label: value.opcion
            })
            ));
    }
}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        estadoConsulta: R.pathOr([], ["estructura_empresas", "estadoConsulta"])(store),
        estructuraEmpresa: R.pathOr(undefined, ["estructura_empresas", "estructuraEmpresa"])(store),
        estructuraSuraEmpresa: R.pathOr(undefined, ["estructura_empresas", "estructuraSuraEmpresa"])(store),
        mensajeUsuario: R.pathOr(undefined, ["estructura_empresas", "mensajeUsuario"])(store),
        consecutivoProceso: R.pathOr(undefined, ["estructura_empresas", "consecutivoProceso"])(store),
        error: R.pathOr(undefined, ["estructura_empresas", "error"])(store),
    };
})(EstructuraEmpresas);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/estructura_empresas/componentes/EstructuraEmpresas.tsx